// import "jquery";

const $icons = $('.header-wrapper .icon-menu');
const $subnavItems = $('#primary-menu .submenu-content.menu-item-has-children');
const $autoExpandingItem = $('#menu--solutions');

function openMenu() {
    $icons.toggleClass('active');
    $('#primary-menu').addClass('active');
    $('#icon-menu-open').attr('aria-expanded', 'true');
    $('#icon-menu-close').attr('aria-hidden', 'false');
}

function closeMenu() {
    $icons.toggleClass('active');
    $('#primary-menu').removeClass('active');
    $('#icon-menu-open').attr('aria-expanded', 'false');
    $('#icon-menu-close').attr('aria-hidden', 'true');
}

function showChildren(el) {
    $subnavItems.removeClass('show');
    $(el).addClass('show');
    $(el).find('> .dropdown-menu').addClass('show');
    $('#primary-menu').addClass('showing-grandchildren');
}

function mobileNavToggle() {
    if ($('#primary-menu').hasClass('active')) {
        closeMenu();
    } else {
        openMenu();
        showChildren($autoExpandingItem);
    }
}

function mobileNavInit() {
    if ($('#primary-menu')) {
        $icons.on('click', () => {
            mobileNavToggle();
        });

        // open menu by pressing return
        $icons.keydown((event) => {
            if (event.keyCode === 13) {
                mobileNavToggle();
            }
        });

        // close mobile nav by pressing escape
        $(document).keyup((event) => {
            if (event.keyCode === 27 && $('#primary-menu').hasClass('active')) {
                closeMenu();
            }
        });

        // Expand the Products > Clorox section so it's immediately visible upon
        // expanding the Products section.
        // On preview the menu has slug 'prototypes' instead of 'products' like on a
        // fresh local build.
        const $promotedProducts = $(
            '#dropdown-menu--products > .menu-item-has-children:first-child, #dropdown-menu--prototypes > .menu-item-has-children:first-child'
        );
        $('#menu--products > a, #menu--prototypes > a').on('click', () => $promotedProducts.addClass('show'));
    }
}

jQuery(document).ready(() => {
    mobileNavInit();
});
